import { SvgIcon } from '@mui/material';
import React from 'react';

export default function BarChartIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 44 44" style={{ width: `22px`, height: `22px`, color: `#1D1D1B`, ...props.style }}>
      <g>
        <path d="M9.39,43.52c-1.1,0-2-.9-2-2V11.53c0-1.1,.9-2,2-2s2,.9,2,2v29.99c0,1.1-.9,2-2,2Z" />
        <path d="M22,43.52c-1.1,0-2-.9-2-2V23.01c0-1.1,.9-2,2-2s2,.9,2,2v18.52c0,1.1-.9,2-2,2Z" />
        <path d="M34.61,43.52c-1.1,0-2-.9-2-2V2.48c0-1.1,.9-2,2-2s2,.9,2,2V41.52c0,1.1-.9,2-2,2Z" />
      </g>
    </SvgIcon>
  );
}
